<!-- <div class="header">
    <h1 mat-dialog-title>Account Not Updated</h1>
</div> -->
<div mat-dialog-content>
    <p class="dialog-message">

        <b>Attention: It is time to review and update your myBGCA profile to ensure that your information is up to date.</b>

    </p>

    <p class="dialog-message">Please click on the Update Account link to begin the review process.</p>

    <p class="dialog-message">Thank You.</p>
</div>
<div mat-dialog-actions class="alignItemsCenter">
    <button class="btn btn-primary" (click)="updateAccount()">Update Account</button>
</div>